import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import * as constants from '../../app.constants';

@Component({
    selector: 'logout',
    template: require('./logout.component.html')
})
export class LogoutComponent {

  public errorMsg: string;

  constructor(
      private router: Router,
      private adminService: AdminService) {
  }

  public logout(): void {
    let email = localStorage.getItem('email');
    let accessToken = localStorage.getItem('accessToken');
    console.log(`Logging out ${email}`);
    this.clearLocalData();
    this.router.navigate(['/login']);

    /* this.adminService
      .getCall(constants.URLs.logout, true)
      .then((res) => {
          console.log('res');
          console.log(res);
          if (res.status == 1 && res.response && res.response.message) {
              this.clearLocalData();
              this.router.navigate(['/login']);
          } else if (res.error && res.error.errors && res.error.errors.length) {
              this.errorMsg = res.error.errors[0].message;
          } else {
              this.errorMsg = res.error.message;
          }
      })
      .catch((error: any) => {
          console.error('LogoutComponent- an error occurred', error);
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
      }); */
  }

  protected clearLocalData(): void {
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('email');
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/logout/logout.component.ts